if(document.querySelector('.dashboard-offices')) {
    let archive = document.querySelector('.floors-archive')
    let single = document.querySelector('.floor-single')
    let appendFloors = document.querySelector('.floors-grid .line')
    let title = document.querySelector('h1')
    let appendConfs = document.querySelector('.confs-grid .line')
    let appendOffices = document.querySelector('.offices-list')
    let closeSingle = document.querySelector('.close-floor-single')
    let rendered = {
        floors: {},
        confs: {},
        offices: {},
    }
    let officesData = {}
    let selectedFloor = 0
    let selectedOffice = 0
    let addConfBtn = document.querySelector('.add-conf')
    let addOfficePopup = document.querySelector('.add-office-popup')
    let selectBlocks = document.querySelectorAll('.select-block')
    let addOfficebtn = document.querySelector('.add-office')
    let editOfficePopup = document.querySelector('.edit-office-popup')

    /// POPUPS

    if(addOfficePopup) {
        let btn = addOfficePopup.querySelector('.btn')

        btn.addEventListener('click', (e) => {
            e.preventDefault()

            let form = addOfficePopup.querySelector('form')
            let fields = {
                name: 1,
            }
            let selectConf = addOfficePopup.querySelector('.select-conf')
            let selectUser = addOfficePopup.querySelector('.select-user')
            let conf = selectConf.selected
            let user = selectUser.selected
            let floor = selectedFloor
            let data = {floor, conf, user}
            let errors = 0

            for(let key in fields) {
                let required = fields[key]
                let field = form.querySelector('.' + key)
        
                if(field) {
                    let value = field.getValue()
        
                    if(required) {
                        errors += field.check()
                    }
        
                    data[key] = value
                }
            }
        
            if(!errors) {
                btn.disable(true)

                requestAxios('createOffice', data, async (office) => {
                    let {id} = office
                    officesData.data.offices[id] = office
                    
                    if(floor)
                        officesData.relations.floorOffices[floor].push(id)

                    if(conf)
                        officesData.relations.confOffices[conf].push(id)

                    officesData.relations.officeConf[id] = conf
                    officesData.relations.officeUser[id] = user

                    let element = await renderOffice(office)
                    appendOffices.prepend(element)
                    
                    floor = rendered.floors[floor]
                    if(floor) {
                        floor.render.offices()
                    }

                    btn.enable()

                    for(let key in fields) {
                        let field = form.querySelector('.' + key)
                
                        if(field) {
                            field.value = ''
                        }
                    }

                    closePopup(addOfficePopup)
                })
            }
        })
    }

    if(editOfficePopup) {
        let btn = editOfficePopup.querySelector('.btn')

        btn.addEventListener('click', (e) => {
            e.preventDefault()

            let form = editOfficePopup.querySelector('form')
            let fields = {
                name: 1,
            }
            let id = selectedOffice
            let selectConf = editOfficePopup.querySelector('.select-conf')
            let selectUser = editOfficePopup.querySelector('.select-user')
            let conf = selectConf.selected
            let user = selectUser.selected
            let data = {id, conf, user}
            let errors = 0

            for(let key in fields) {
                let required = fields[key]
                let field = form.querySelector('.' + key)
        
                if(field) {
                    let value = field.getValue()
        
                    if(required) {
                        errors += field.check()
                    }
        
                    data[key] = value
                }
            }
        
            if(!errors) {
                btn.disable(true)

                requestAxios('editOffice', data, async () => {
                    let office = officesData.data.offices[id]
                    let oldConf = officesData.relations.officeConf[id]

                    office.name = data.name

                    if(oldConf) {
                        let index = officesData.relations.confOffices[oldConf].indexOf(id)
                        officesData.relations.confOffices[oldConf].splice(index)
                    }

                    if(conf)
                        officesData.relations.confOffices[conf].push(id)

                    officesData.relations.officeConf[id] = conf
                    officesData.relations.officeUser[id] = user

                    let element = rendered.offices[id]

                    for(let key in element.render) {
                        element.render[key]()
                    }

                    btn.enable()

                    for(let key in fields) {
                        let field = form.querySelector('.' + key)
                
                        if(field) {
                            field.value = ''
                        }
                    }

                    closePopup(editOfficePopup)
                })
            }
        })
    }

    /// METHODS

    for(let element of selectBlocks) {
        Object.defineProperty(element, 'selected', {
            set: function(id) {
                let items = element.querySelectorAll('.item')

                for(let item of items) {
                    let {value} = item.dataset

                    if(Number(value) == id) {
                        item.classList.add('active')
                    } else {
                        item.classList.remove('active')
                    }
                }

                return this.selectedKey = id
            },
            get: function() {
                return this.selectedKey
            }
        })
    }

    let updateConfsList = () => {
        let structure = ['<div class="item icon-checked" data-value="0">Не выбрано</div>']
        let items = officesData.relations.floorConfs[selectedFloor]
        let append = document.querySelectorAll('.select-conf')
        
        if(items.length) {
            for(let confId of items) {
                let conf = officesData.data.confs[confId]
                let {name, id} = conf

                structure.push(`<div class="item icon-checked" data-value="${id}">${name}</div>`)
            }
        }

        structure = structure.join('')

        for(let wrapper of append) {
            wrapper.innerHTML = structure
            let items = wrapper.querySelectorAll('.item')

            for(let item of items) {
                let {value} = item.dataset

                item.addEventListener('click', () => {
                    wrapper.selected = Number(value)
                })
            }
        }
    }

    let updateUsersList = () => {
        console.log(officesData);
        let structure = ['<div class="item icon-checked" data-value="0">Не выбрано</div>']
        let users = officesData.data.users
        let append = document.querySelectorAll('.select-user')
        
        for(let user of Object.values(users)) {
            let {display_name, ID} = user

            structure.push(`<div class="item icon-checked" data-value="${ID}">${display_name}</div>`)
        }

        structure = structure.join('')

        for(let wrapper of append) {
            wrapper.innerHTML = structure
            let items = wrapper.querySelectorAll('.item')

            for(let item of items) {
                let {value} = item.dataset

                item.addEventListener('click', () => {
                    wrapper.selected = Number(value)
                })
            }
        }
    }

    /// ELEMENTS
    let addConfElement = document.createElement('form')
    addConfElement.innerHTML = `
    <input type="text" class="text" placeholder="Наименование">
    `
    addConfElement.classList.add('conf-item')
    
    let addConfInput = addConfElement.querySelector('input')

    /// EVENTS

    addConfInput.addEventListener('focusout', async () => {
        addConfInput.value = ''
        appendConfs.removeChild(addConfElement)
    })

    addConfElement.addEventListener('submit', async (e) => {
        e.preventDefault()

        let value = addConfInput.getValue()

        if(value) {
            let data = {
                floor: selectedFloor,
                name: value
            }

            requestAxios('createConf', data, async (conf) => {
                let {id} = conf
                officesData.data.confs[id] = conf
                officesData.relations.floorConfs[selectedFloor].push(id)
                officesData.relations.confOffices[id] = []

                let element = await renderConf(conf)
                appendConfs.appendChild(element)
                
                let floor = rendered.floors[selectedFloor]
                
                if(floor) {
                    floor.render.confs()
                }

                updateConfsList()
            })
        }

        addConfInput.blur()
    })

    addConfBtn.addEventListener('click', () => {
        appendConfs.appendChild(addConfElement)
        addConfInput.focus()
    })

    closeSingle.addEventListener('click', () => {
        selectedFloor = 0

        archive.classList.add('show')
        single.classList.remove('show')
        closeSingle.classList.remove('show')

        title.textContent = 'Офисы'
    })

    addOfficebtn.addEventListener('click', () => {
        let selectConf = addOfficePopup.querySelector('.select-conf')
        let selectUser = addOfficePopup.querySelector('.select-user')

        selectConf.selected = 0
        selectUser.selected = 0

        openPopup(addOfficePopup)
    })

    /// DATA

    requestAxios('officesInfo', '', async (res) => {
        officesData = res

        appendFloors.innerHTML = ''

        let floors = officesData.data.floors
        if(Object.keys(floors).length) {
            for(let key in floors) {
                let floor = floors[key]
                let element = await renderFloor(floor)

                appendFloors.appendChild(element)
            }
        }

        updateUsersList()
    })

    /// RENDER

    async function renderFloor(data) {
        let {id} = data
        let element

        if(rendered.floors[id]) {
            element = rendered.floors[id]
        } else {
            element = await document.createElement('div')
            element.innerHTML = `
            <div class="name"></div>
            <div class="stats">
                <div class="icon-building offices-count"></div>
                <div class="icon-conf confs-count"></div>
            </div>
            `
            element.classList.add('floor')
    
            let nameElement = element.querySelector('.name')
            let officesElement = element.querySelector('.offices-count')
            let confsElement = element.querySelector('.confs-count')

            ////

            element.addEventListener('click', async () => {
                let {id, floor} = data
                selectedFloor = id

                archive.classList.remove('show')
                single.classList.add('show')
                closeSingle.classList.add('show')

                title.textContent = `${floor} этаж`

                //

                appendConfs.innerHTML = ''

                let confs = officesData.relations.floorConfs[id]

                if(confs.length) {
                    for(let confId of confs) {
                        let conf = officesData.data.confs[confId]
                        let element = await renderConf(conf)

                        appendConfs.appendChild(element)
                    }
                }

                //

                appendOffices.innerHTML = ''

                let offices = officesData.relations.floorOffices[id]

                console.log(offices);
                if(offices.length) {
                    for(let officeId of offices) {
                        let office = officesData.data.offices[officeId]
                        let element = await renderOffice(office)

                        appendOffices.appendChild(element)
                    }
                }

                updateConfsList()
            })

            ////
    
            element.render = {
                name: async () => {
                    let {floor} = data
    
                    nameElement.textContent = `${floor} этаж`
                },
                offices: async () => {
                    let {id} = data
                    let count = officesData.relations.floorOffices[id].length

                    officesElement.textContent = count
                },
                confs: async () => {
                    let {id} = data
                    let count = officesData.relations.floorConfs[id].length

                    confsElement.textContent = count
                }
            }

            for(let key in element.render) {
                await element.render[key]()
            }

            rendered.floors[id] = element
        }

        return element
    }

    async function renderConf(data) {
        let {id} = data
        let element

        if(rendered.confs[id]) {
            element = rendered.confs[id]
        } else {
            element = await document.createElement('div')
            element.innerHTML = `
            <input type="text" class="text" placeholder="Наименование">
            <div class="remove-conf-item icon-trash"></div>
            <a href="/schedule/?id=${id}" target="_blank" class="conf-schedule icon-calendar"></a>
            `
            element.classList.add('conf-item')

            let nameElement = element.querySelector('input')
            let closeElement = element.querySelector('.remove-conf-item')

            ////

            nameElement.addEventListener('change', () => {
                let {id, name} = data
                let value = nameElement.getValue()

                if(value != name && value) {
                    data.name = value

                    requestAxios('changeConfName', {id, name: value}, () => {
                        let confOffices = officesData.relations.confOffices[id]

                        console.log(officesData.relations);
                        console.log(confOffices);

                        if(confOffices.length) {
                            for(let officeId of confOffices) {
                                let office = rendered.offices[officeId]

                                if(office) {
                                    office.render.conf()
                                }
                            }
                        }
                    })
                } else {
                    nameElement.value = name
                }
            })

            closeElement.addEventListener('click', () => {
                let {id} = data
                let confOffices = officesData.relations.confOffices[id]

                if(confOffices.length) {
                    let names = []
                    for(let officeId of confOffices) {
                        let name = officesData.data.offices[officeId].name

                        names.push(name)
                    }

                    names = names.join(', ')

                    add_notif({
                        title: 'Удаление конференц зала',
                        text: `Вы не можете удалить зал пока к нему привязаны офисы: ${names}`,
                        color: 'red',
                        icon: 'error',
                        timeout: 4000
                    })
                } else {
                    add_notif({
                        title: 'Удаление конференц зала',
                        text: 'Вы уверены что хотите удалить конференц зал?',
                        color: 'red',
                        icon: 'warning',
                        btns: [
                            {
                                text: 'Удалить',
                                type: 'text',
                                color: 'red',
                                onClick: (elem) => {
                                    closeNotif(elem)
                                    requestAxios('removeConf', {id}, () => {
                                        let floor = rendered.floors[selectedFloor]

                                        rendered.confs[id].remove()
                                        delete rendered.confs[id]

                                        let floorConfs = officesData.relations.floorConfs[selectedFloor]
                                        let index = floorConfs.indexOf(id)

                                        if(index != -1) {
                                            floorConfs.splice(index, 1)
                                        }

                                        if(floor) {
                                            floor.render.confs()
                                        }
                                    })
                                }
                            },
                            {
                                text: 'Отмена',
                                type: 'text',
                                style: 'outline',
                                onClick: (elem) => {
                                    closeNotif(elem)
                                }
                            }
                        ]
                    })
                }
            })

            ////
    
            element.render = {
                name: async () => {
                    let {name} = data

                    nameElement.value = name
                }
            }

            for(let key in element.render) {
                await element.render[key]()
            }

            rendered.confs[id] = element
        }

        return element
    }

    async function renderOffice(data) {
        let {id} = data
        let element

        if(rendered.offices[id]) {
            element = rendered.offices[id]
        } else {
            element = await document.createElement('div')
            element.innerHTML = `
            <div class="offices-list-item-info">
                <div class="number"></div>
                <div class="name"></div>
                <div class="user icon-building"></div>
                <div class="conf icon-conf"></div>
                <div class="action icon-edit edit-office"></div>
                <div class="action icon-close remove-office"></div>
            </div>
            `
            element.classList.add('offices-list-item')

            let nameElement = element.querySelector('.name')
            let userElement = element.querySelector('.user')
            let confElement = element.querySelector('.conf')
            let editElement = element.querySelector('.edit-office')
            let removeElement = element.querySelector('.remove-office')

            ////

            removeElement.addEventListener('click', () => {
                add_notif({
                    title: 'Удаление офиса',
                    text: 'Вы уверены что хотите удалить офис?',
                    color: 'red',
                    icon: 'warning',
                    btns: [
                        {
                            text: 'Удалить',
                            type: 'text',
                            color: 'red',
                            onClick: (elem) => {
                                closeNotif(elem)
                                requestAxios('removeOffice', {id}, () => {
                                    let floor = rendered.floors[selectedFloor]

                                    rendered.offices[id].remove()
                                    delete rendered.offices[id]

                                    let floorOffices = officesData.relations.floorOffices[selectedFloor]
                                    let index = floorOffices.indexOf(id)

                                    if(index != -1) {
                                        floorOffices.splice(index, 1)
                                    }

                                    let confId = officesData.relations.officeConf[id]

                                    if(confId) {
                                        let confOffices = officesData.relations.confOffices[confId]
                                        let index = confOffices.indexOf(id)
    
                                        if(index != -1) {
                                            confOffices.splice(index, 1)
                                        }

                                        delete officesData.relations.confOffices[confId]
                                    }

                                    let userId = officesData.relations.officeUser[id]

                                    if(userId) {
                                        delete officesData.relations.officeUser[id]
                                    }

                                    if(floor) {
                                        floor.render.offices()
                                    }
                                })
                            }
                        },
                        {
                            text: 'Отмена',
                            type: 'text',
                            style: 'outline',
                            onClick: (elem) => {
                                closeNotif(elem)
                            }
                        }
                    ]
                })
            })

            editElement.addEventListener('click', () => {
                let {id, name} = data
                let conf = officesData.relations.officeConf[id] || 0
                let user = officesData.relations.officeUser[id] || 0

                let nameField = editOfficePopup.querySelector('.name')
                let selectConf = editOfficePopup.querySelector('.select-conf')
                let selectUser = editOfficePopup.querySelector('.select-user')

                nameField.value = name
                selectConf.selected = conf
                selectUser.selected = user

                selectedOffice = id

                openPopup(editOfficePopup)
            })

            ////
    
            element.render = {
                name: async () => {
                    let {name} = data

                    nameElement.textContent = name
                },
                conf: async () => {
                    let {id} = data
                    let confId = officesData.relations.officeConf[id]

                    if(confId) {
                        let conf = officesData.data.confs[confId]   
                        let {name} = conf

                        confElement.textContent = name
                    } else {
                        confElement.textContent = 'Нет конференц зала'
                    }
                },
                user: async () => {
                    let {id} = data
                    let userId = officesData.relations.officeUser[id]

                    if(userId) {
                        let user = officesData.data.users[userId]
                        let name = user.display_name

                        userElement.textContent = name
                    } else {
                        userElement.textContent = 'Нет арендатора'
                    }
                }
            }

            for(let key in element.render) {
                await element.render[key]()
            }

            rendered.offices[id] = element
        }

        return element
    }
}